import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { useOnChange } from "@opensea/ui-kit/hooks";
import { useState } from "react";
import { useAuthenticated } from "@/hooks/wallet";
const query = graphql(`
    query LinkedAddressesQuery {
      walletsByAccount {
        items {
          address
        }
      }
    }
  `);
const CONTEXT = {
  suspense: false
};
export function useLinkedAddresses() {
  const $ = _c(14);
  const authenticated = useAuthenticated();
  const t0 = !authenticated;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      query,
      pause: t0,
      context: CONTEXT,
      requestPolicy: "network-only"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      throwOnError: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [t3, refetch] = useQuery(t1, t2);
  const {
    data,
    fetching
  } = t3;
  let t4;
  if ($[3] !== data?.walletsByAccount?.items) {
    t4 = data?.walletsByAccount?.items.map(_temp) ?? [];
    $[3] = data?.walletsByAccount?.items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [linkedAddresses, setLinkedAddresses] = useState(t4);
  let t5;
  if ($[5] !== data?.walletsByAccount?.items) {
    t5 = () => {
      setLinkedAddresses(data?.walletsByAccount?.items.map(_temp2) ?? []);
    };
    $[5] = data?.walletsByAccount?.items;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useOnChange(data, t5);
  let t6;
  if ($[7] !== authenticated || $[8] !== refetch) {
    t6 = () => {
      if (authenticated) {
        refetch();
      } else {
        setLinkedAddresses([]);
      }
    };
    $[7] = authenticated;
    $[8] = refetch;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const refetchLinkedAddresses = t6;
  let t7;
  if ($[10] !== fetching || $[11] !== linkedAddresses || $[12] !== refetchLinkedAddresses) {
    t7 = {
      linkedAddresses,
      refetchLinkedAddresses,
      fetching
    };
    $[10] = fetching;
    $[11] = linkedAddresses;
    $[12] = refetchLinkedAddresses;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp2(wallet_0) {
  return wallet_0.address;
}
function _temp(wallet) {
  return wallet.address;
}